import R from "ramda";
import {
  DOCUMENT_UPLOADED,
  SET_PENDING_DOCUMENTS,
  LOADING_START,
  FOCUS_PENDING_DOCUMENT,
  CANCEL_PROCESSING,
  SET_TRASH_DOCUMENT_VISIBILITY,
  CANCEL_PROCESSING_ALL_DOCUMENTS,
  PROCESS_ALL_DOCUMENTS,
  REPROCESS_PENDING_DOCUMENT,
  CHANGE_DOCUMENT_TYPE,
  UPLOAD_LOADING_START,
  UPLOAD_LOADING_END,
  CANCEL_PROCESSING_LOADING,
  CANCEL_PROCESSING_LOADING_STOP,
  START_FILTERS_MODE,
  END_FILTERS_MODE,
  ADD_STUCK_STATUS_FILTER,
  REMOVE_STUCK_STATUS_FILTER,
  ADD_SOURCE_FILTER,
  REMOVE_SOURCE_FILTER
} from "actions/pending-documents-actions";
import { REPROCESS_DOCUMENT } from "actions/update-document-actions";
import { SET_ACCOUNT_DETAILS } from "actions/account-settings-actions";

export const initialState = {
  documentType: "receipt",
  focusedDocument: null,
  isBeingCancelled: false,
  isCancelProcessingLoading: false,
  isCancelProcessingVisible: false,
  isFiltersMode: false,
  isLoading: false,
  isTrashDocumentVisible: false,
  isUploadLoading: false,
  pendingDocuments: [],
  pendingFilters: [],
  sourceFilter: null,
  statusFilter: null,
  submissionEmail: ""
};

export const pendingDocumentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACCOUNT_DETAILS:
      return R.merge(state, { submissionEmail: action.data.accountDetails.dropboxEmail });
    case DOCUMENT_UPLOADED:
      return R.merge(state, { pendingDocuments: R.prepend(action.data.data, state.pendingDocuments) });
    case SET_PENDING_DOCUMENTS:
      return stateForSetPendingDocuments(state, action);
    case LOADING_START:
      return R.merge(state, { isLoading: true });
    case FOCUS_PENDING_DOCUMENT:
      return stateForFocusPendingDocument(state, action);
    case CANCEL_PROCESSING:
      return stateForCancelProcessing(state, action);
    case SET_TRASH_DOCUMENT_VISIBILITY:
      return R.merge(state, { isTrashDocumentVisible: action.data.visibility });
    case CANCEL_PROCESSING_ALL_DOCUMENTS:
      return R.merge(state, { pendingDocuments: action.data.documents, isBeingCancelled: true });
    case PROCESS_ALL_DOCUMENTS:
      return R.merge(state, { pendingDocuments: action.data.documents, isBeingCancelled: false });
    case REPROCESS_PENDING_DOCUMENT:
      return R.merge(state, {
        focusedDocument: action.data.newDocument,
        isCancelProcessingVisible: true
      });
    case CHANGE_DOCUMENT_TYPE:
      return R.merge(state, { documentType: action.data.type });
    case UPLOAD_LOADING_START:
      return R.merge(state, { isUploadLoading: true });
    case UPLOAD_LOADING_END:
      return R.merge(state, { isUploadLoading: false });
    case CANCEL_PROCESSING_LOADING:
      return R.merge(state, { isCancelProcessingLoading: true });
    case CANCEL_PROCESSING_LOADING_STOP:
      return R.merge(state, { isCancelProcessingLoading: false });
    case REPROCESS_DOCUMENT:
      return stateForReprocessDocument(state, action);
    case ADD_STUCK_STATUS_FILTER:
      return R.merge(state, { statusFilter: action.data.filter });
    case ADD_SOURCE_FILTER:
      return R.merge(state, { sourceFilter: action.data.filter });
    case REMOVE_STUCK_STATUS_FILTER:
      return R.merge(state, { statusFilter: null });
    case REMOVE_SOURCE_FILTER:
      return R.merge(state, { sourceFilter: null });
    case START_FILTERS_MODE:
      return R.merge(state, { isFiltersMode: true });
    case END_FILTERS_MODE:
      return R.merge(state, { isFiltersMode: false });
    default:
      return state;
  }
};

const stateForFocusPendingDocument = (state, action) => {
  const visibility = action.data.document.processingState !== "NEEDS_USER_PROCESSING";
  return R.merge(state, {
    focusedDocument: action.data.document,
    isCancelProcessingVisible: visibility
  });
};

const stateForSetPendingDocuments = (state, action) => {
  let visibility = true;
  if ((action.data.newDocuments[0] || []).processingState === "NEEDS_USER_PROCESSING") {
    visibility = false;
  }
  return R.merge(state, {
    focusedDocument: action.data.newDocuments[0],
    isCancelProcessingVisible: visibility,
    isLoading: false,
    pendingDocuments: action.data.newDocuments
  });
};

const stateForReprocessDocument = (state, action) => {
  const newPendingDocuments = R.append(action.data.newDocument, state.pendingDocuments);
  return R.merge(state, { pendingDocuments: newPendingDocuments });
};

const stateForCancelProcessing = (state, action) => {
  const updatedDocumentIndex = R.findIndex(R.propEq("id", action.data.newDocument.id))(state.pendingDocuments);
  const lens = R.lensIndex(updatedDocumentIndex);
  const oldDocument = R.findIndex(lens, state.pendingDocuments);
  const updatedDocument = R.merge(oldDocument, action.data.newDocument);
  const newPendingDocuments = R.set(lens, updatedDocument, state.pendingDocuments);
  return R.merge(state, {
    focusedDocument: action.data.newDocument,
    isCancelProcessingVisible: false,
    pendingDocuments: newPendingDocuments
  });
};



// WEBPACK FOOTER //
// ./src/js/reducers/pending-documents-reducer.js